// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Cli8x","link":"styles_link__3-OM1","buttonClose":"styles_buttonClose__A-lKw"};